// Dictionary
import { uri } from '../data-util'
import langs from './language.json'
// Builder
import { html, render } from 'lit'
import 'view-base/unit-link'
// Selector
import { get as val } from 'object-path'
import { provider } from './provider'
import * as util from '../view-advice-util'

export function textTable( xeon, state ) {

  const lang = uri.lang()
  const dict = langs[ lang ]
  const data = provider( xeon )
  // Group by adverse event for the first 10
  // and the rest in the text
  const ades = data.table( lang )

  // ------------------------
  // HEAD
  // ------------------------
  const head = []
  const cols = []
  // Chapter
  cols.push( html `<th>
    ${ dict.head }
  </th>` )
  // Frequency
  cols.push( html `<th>
    <span style="font-size:1.2em;">&sum;</span>
    ${dict.frequency}
  </th>` )
  for ( const item of Object.values( xeon.drugs ) ) {
    cols.push( html `<th>${item.name[lang].substr(0,3)}</th>` )
  }
  // Finalize
  head.push( html `<tr>${cols}</tr>` )

  // ------------------------
  // BODY
  // ------------------------
  const rows = []

  // TOPTEN
  for ( const ade of ades ) {
    const cells = []
    // Incremental risk
    const incr = Object.keys( ade.drugs ).length > 1
    // Name of adverse event
    cells.push( html `<td>${util.capitalize(ade.text)}</td>` )
    // Frequency
    if( incr ) {
      cells.push( html `<td><b>${ade.sum.toFixed(1)} %</b></td>` )
    } else {
      cells.push( html `<td>${ade.sum.toFixed(1)} %</td>` )
    }
    // Iterate
    for ( const drug of Object.values( xeon.drugs ) ) {
      if ( ade.drugs[ drug.id ] && ade.drugs[ drug.id ].freq > 0 ) {
        const { freq, aucr } = ade.drugs[ drug.id ]
        if ( freq == 1 ) {
          cells.push( html `<td>+</td>` )
        } else {
          // Round to the first non-zero digit after decimal, with minimum of 1 digit
          const freqFixed = freq.toFixed(
            Math.max( 1, -Math.floor( Math.log( freq ) / Math.log( 10 ) ) )
          )
          if ( aucr > 2 ) {
            cells.push( html `<td style="${colorize(freq, incr)}">${freqFixed}&uarr;</td>` )
          } else if ( aucr < 0.7 && aucr > 0 ) {
            cells.push( html `<td style="${colorize(freq, incr)}">${freqFixed}&darr;</td>` )
          } else {
            cells.push( html `<td style="${colorize(freq, incr)}">${freqFixed}</td>` )
          }
        }
      } else {
        cells.push( html `<td>n.a.</td>` )
      }
    }
    // Finalize row
    if( incr ) {
      rows.push( html `<tr>${cells}</tr>` )
    } else {
      // Show disabled not adding to incremental risk
      rows.push( html `<tr disabled>${cells}</tr>` )
    }
  }

  // ------------------------------
  // Legende with factors
  // ------------------------------
  const refs = []
  // Serious
  refs.push( html `
    <span>${dict.topis}</span>
    <br>
    <span>${dict.plus}</span>
    <br>
    <span>${dict.arrows}</span>
  ` )

  refs.push

  return html `
    <table class="adverse zahl">
      <thead>${ head }</thead>
      <tbody>${ rows }</tbody>
    </table>
    <div class=caption>${ refs }</div>
    `
}

function colorize( value, incr ) {

  if ( value > 1 && incr ) {
    return `background:rgba(247,103,158,${Math.min(value/30,0.8)});`
  }

  return ""
}
